import './App.css';

function QuestionSent() {
  return (
    <div style={{height: '760px'}}>
        <div className="flex justify-center">
            <img className="logo" src="logo_new.png" />
        </div>
        <p class="text-center sent-txt">We have received your<br/>question, <span class='font-bold'>thanks!</span></p>
    </div>
  );
}

export default QuestionSent;
